import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=2490d95d&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=2490d95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490d95d",
  null
  
)

export default component.exports